import * as Yup from 'yup';
import moment from 'moment';
import { limparDocumento } from '../../../utils/documentoAlfanumerico';

const isValidDDMMYYYY = v => {
  if (!v) return true;
  return moment(v, 'DD/MM/YYYY', true).isValid();
};

const toNumberOrNull = v => {
  if (v === '' || v == null) return null;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : NaN;
};

// vem com 14 dias
export const atualizacaoTituloFiltroInicial = {
  data_inicio: moment()
    .subtract(14, 'days')
    .format('DD/MM/YYYY'),
  data_final: moment().format('DD/MM/YYYY'),

  valor_min: '',
  valor_max: '',
  cpfcnpj_sacado: '',
  nome_sacado: '',
  vencimento_inicio: '',
  vencimento_final: '',
  ndoc: '',
  bordero: ''
};

export const atualizacaoTituloFiltroSchema = Yup.object().shape({
  data_inicio: Yup.string()
    .nullable()
    .required('Período obrigatório.')
    .test('date-format', 'Data inválida (DD/MM/AAAA).', isValidDDMMYYYY),

  data_final: Yup.string()
    .nullable()
    .required('Período obrigatório.')
    .test('date-format', 'Data inválida (DD/MM/AAAA).', isValidDDMMYYYY)
    .test('date-range', 'Data final deve ser maior ou igual à inicial.', function(value) {
      const { data_inicio } = this.parent;
      if (!value || !data_inicio) return true;

      const ini = moment(data_inicio, 'DD/MM/YYYY', true);
      const fim = moment(value, 'DD/MM/YYYY', true);
      if (!ini.isValid() || !fim.isValid()) return true;

      return fim.isSameOrAfter(ini, 'day');
    }),

  valor_min: Yup.string()
    .nullable()
    .test('is-number', 'Valor mínimo inválido.', v => {
      if (v === '' || v == null) return true;
      const n = toNumberOrNull(v);
      return Number.isFinite(n);
    }),

  valor_max: Yup.string()
    .nullable()
    .test('is-number', 'Valor máximo inválido.', v => {
      if (v === '' || v == null) return true;
      const n = toNumberOrNull(v);
      return Number.isFinite(n);
    })
    .test('range', 'Valor máximo deve ser maior ou igual ao mínimo.', function(value) {
      const { valor_min } = this.parent;
      const min = toNumberOrNull(valor_min);
      const max = toNumberOrNull(value);
      if (min == null || max == null) return true;
      if (!Number.isFinite(min) || !Number.isFinite(max)) return true;
      return max >= min;
    }),

  cpfcnpj_sacado: Yup.string()
    .nullable()
    .test('cpfcnpj', 'CPF/CNPJ inválido.', v => {
      if (!v) return true;
      const documento = limparDocumento(v);
      if (documento.length === 0) return true;
      if (documento.length < 11) return true;
      return documento.length === 11 || documento.length === 14;
    }),

  nome_sacado: Yup.string()
    .nullable()
    .max(255, 'Nome muito longo.'),

  vencimento_inicio: Yup.string()
    .nullable()
    .test('date-format', 'Data inválida (DD/MM/AAAA).', isValidDDMMYYYY),

  vencimento_final: Yup.string()
    .nullable()
    .test('date-format', 'Data inválida (DD/MM/AAAA).', isValidDDMMYYYY)
    .test('date-range', 'Vencimento final deve ser maior ou igual ao inicial.', function(value) {
      const { vencimento_inicio } = this.parent;
      if (!value || !vencimento_inicio) return true;

      const ini = moment(vencimento_inicio, 'DD/MM/YYYY', true);
      const fim = moment(value, 'DD/MM/YYYY', true);
      if (!ini.isValid() || !fim.isValid()) return true;

      return fim.isSameOrAfter(ini, 'day');
    }),

  ndoc: Yup.string()
    .nullable()
    .max(50, 'NDOC muito longo.'),
  bordero: Yup.string()
    .nullable()
    .max(50, 'Borderô muito longo.')
});

export default atualizacaoTituloFiltroSchema;
